import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { FetchLoadCalendar, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IState } from '../..';
import { getLogisticsUserWarehouses } from '../../auth';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../logisticsApi';

function* fetchLoadCalendarSaga(action: FetchLoadCalendar) {
  yield put(uiActionCreators.toggleLoading('loadCalendar'));
  const warehouses = yield* select((state: IState) => getLogisticsUserWarehouses(state));

  const response = yield* call(
    api.fetchMinLoads,
    { startDate: action.payload.start, endDate: action.payload.end },
    warehouses
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setMinLoads(response.value));
  }

  yield put(uiActionCreators.toggleLoading('loadCalendar'));
}

export function* watchFetchLoadCalendar() {
  yield takeEvery(LogisticsActionKeys.FETCH_LOAD_CALENDAR, fetchLoadCalendarSaga);
}
